export const showProductImagePlaceholder = (event) => {
  const image = event?.currentTarget;
  if (!image) return;
  image.style.display = "none";
  if (image.nextSibling?.style) image.nextSibling.style.display = "flex";
};

// Only use URLs already supplied by the catalogue; never derive replacement paths.
export const productImageCandidates = (product) => {
  const candidates = [product?.ImageUrl, ...(Array.isArray(product?.Images) ? product.Images : []),
    ...(Array.isArray(product?.Variants) ? product.Variants.map(variant => variant?.ImageUrl) : [])];
  return [...new Set(candidates.flatMap(value => {
    if (typeof value !== "string" || !value.trim()) return [];
    try {
      const url = new URL(value.trim());
      if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) return [];
      if (/\.(?:pdf|docx?|xlsx?|csv|txt|html?)$/i.test(url.pathname)) return [];
      return [url.href];
    } catch { return []; }
  }))];
};

export const showNextProductImage = (event, product) => {
  const image = event?.currentTarget;
  if (!image) return;
  const candidates = productImageCandidates(product);
  const next = candidates[candidates.indexOf(image.src) + 1];
  if (!next) return showProductImagePlaceholder(event);
  image.src = next;
};
